import moment from "moment";

// Filtros da página guardados por usePersistedFilters('financeiro.contasPagar').
// Só valores serializáveis: mês 'YYYY-MM', período personalizado em 'YYYY-MM-DD'.
export var getDefaultContasPagarFilters = function() {
    return {
        month: moment().format("YYYY-MM"),
        customRange: null,
        view: "all",
        search: "",
    };
};

var hasCustomRange = function(filters) {
    return !!(filters && filters.customRange && filters.customRange.from && filters.customRange.to);
};

// Transforma o filtro salvo nos parâmetros de /contas-pagar: o período
// personalizado, se houver, senão o mês inteiro.
export var getContasPagarPeriodRequest = function(filters) {
    if (hasCustomRange(filters)) {
        return { from: filters.customRange.from, to: filters.customRange.to, status: "all" };
    }
    var m = moment(filters.month, "YYYY-MM");
    return {
        from: m.clone().startOf("month").format("YYYY-MM-DD"),
        to: m.clone().endOf("month").format("YYYY-MM-DD"),
        status: "all",
    };
};

export var isContasPagarPeriodDefault = function(filters, defaults) {
    return !hasCustomRange(filters) && filters.month === defaults.month;
};

// Badge do botão Filtros: só o que difere do padrão.
export var countActiveContasPagarFilters = function(filters, defaults) {
    return (isContasPagarPeriodDefault(filters, defaults) ? 0 : 1) +
        (filters.view !== defaults.view ? 1 : 0) +
        (filters.search ? 1 : 0);
};
